import React, { useCallback } from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Button, Tooltip } from "antd";
// import { FileExcelOutlined } from "@ant-design/icons";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExportToExcel = ({ getRoutesData, fileName, buttonName, disable }) => {
	const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";

	const exportToCSV = useCallback((getRoutesData, fileName) => {
		const apiData = getRoutesData();
		if (apiData) {
			const ws = XLSX.utils.json_to_sheet(apiData);
			const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
			const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
			const data = new Blob([excelBuffer], { type: fileType });
			FileSaver.saveAs(data, fileName + fileExtension);
		}
	}, []);



	return (
		<Tooltip title="">
			<Button
				className="blueclr"
				disabled={disable}
				
				onClick={() => exportToCSV(getRoutesData, fileName)}
			>
				<FontAwesomeIcon className="mr-2" icon={faDownload} /> {buttonName}
			</Button>
		</Tooltip>
	);
};

export default ExportToExcel;
